import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import FormField from '@ingka/form-field';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import { DropDownProps, StyledDropdown } from '../StyledDropdown';
import { HashFullWidthProps } from './ValidatedInputField';

interface ValidatedDropDownFieldProps extends DropDownProps {
  validatedField: string | null;
  onBlur?: () => void;
  isSubmitBtnClicked: boolean;
  fullwidth: string;
}

const StyledFormField = styled(FormField)`
  width: ${(props: HashFullWidthProps): string =>
    props.fullwidth ? '100%' : 'calc(50% - 10px)'};
`;

export const ValidatedDropDownField: React.FC<ValidatedDropDownFieldProps> = ({
  id,
  label,
  value,
  onChange,
  onBlur = (): void => {
    /**/
  },
  validatedField,
  isSubmitBtnClicked,
  options,
  fullwidth
}): JSX.Element => {
  const { t } = useTranslation();
  const [validationId] = useState(`invalid-${Math.random().toString(36)}`);
  const isValid = !(isSubmitBtnClicked && validatedField !== null);

  return (
    <StyledFormField
      valid={isValid}
      shouldValidate={isSubmitBtnClicked}
      validation={{
        id: validationId,
        msg: t(validatedField as string),
      }}
      {...(fullwidth ? { fullwidth: fullwidth.toString() } : {})}
    >
      <StyledDropdown
        id={id}
        valid={isValid}
        label={label}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        options={options && options.length > 1 ? options : []}
        describedById={isValid ? undefined : validationId}
      />
    </StyledFormField>
  );
};
